(() => {
  const sync = () => {
    document.querySelectorAll('[data-pp-express-card]').forEach(node => {
      const card = node.closest('.product-card');
      const id = card?.querySelector('[name="id"]')?.value || node.dataset.initial;
      node.querySelectorAll('[data-express-variant]').forEach(label => {
        const hidden = label.dataset.expressVariant !== id;
        if (label.hidden !== hidden) label.hidden = hidden;
      });
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  };
  document.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  sync();
})();
